import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import english from './locale/en.json'

i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  lowerCaseLng: true,
  partialBundledLanguages: true,
  resources: { en: { translation: english } },
  interpolation: { escapeValue: false }
})

export default i18next
